export function isNullishOrEmpty(item: unknown) {
  return item == null || item === "";
}

export function filterRecord(
  record: Record<string, unknown>,
  predicate: (key: string, value: unknown) => boolean,
) {
  return Object
    .entries(record)
    .reduce((acc, [key, value]) => predicate(key, value)
      ? { ...acc, [key]: value }
      : acc,
    {});
}

export function removeNullishOrEmpty(record: Record<string, unknown>) {
  return filterRecord(
    record,
    (_, value) => !isNullishOrEmpty(value),
  );
}
